module.exports = __webpack_public_path__ + "static/banner-health-grayscaled-aceb867bd18e664c614b392c92b8bb23.png";